var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0-18 0" }),
      createElementVNode("path", { d: "M12 7v5l3 3" })
    ], -1)
  ]));
}
__name(render, "render");
const clock = markRaw({ name: "tabler-clock", render });
export {
  clock as default
};
//# sourceMappingURL=clock.js.map
